import { useState } from 'react';
import { Link } from 'react-router-dom';

const tabs = [
  { key: 'home', label: 'Home', path: '.' },
  { key: 'campaigns', label: 'Campaigns', path: 'campaigns' },
  { key: 'creators', label: 'Creators', path: 'creators' },
  { key: 'finance', label: 'Finance', path: 'finance' },
  { key: 'profile', label: 'Profile', path: 'profile' },
];

export function MobileModule(): JSX.Element {
  const [active, setActive] = useState('home');
  const current = tabs.find((tab) => tab.key === active) ?? tabs[0]!;

  return (
    <div className="mobile-module">
      <div className="mobile-module-header"><h2>Mobile Workspace</h2><span className="status-badge">Responsive</span></div>
      <div className="mobile-module-content">
        <h3>{current.label}</h3>
        <p className="muted">This mobile view uses the same tenant-scoped API and permissions as desktop.</p>
        <Link className="btn btn-primary" to={current.path === '.' ? '.' : `../${current.path}`}>Open {current.label}</Link>
      </div>
      <nav className="mobile-module-tabs" aria-label="Mobile workspace navigation">
        {tabs.map((tab) => <button key={tab.key} type="button" className={active === tab.key ? 'active' : ''} onClick={() => setActive(tab.key)}>{tab.label}</button>)}
      </nav>
    </div>
  );
}